import * as React from 'react';

import { LocaleResponse } from 'api/api';

export const TranslationsContext = React.createContext<LocaleResponse>({
  translations: {},
  locale: 'en-US',
});
